import { render, staticRenderFns } from "./add-contact-action.vue?vue&type=template&id=5ef9d77a"
import script from "./add-contact-action.ts?vue&type=script&lang=js&external"
export * from "./add-contact-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports